<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="PublishingProjects"
                :alvqa="alvqa"
            /> 
            <ImportButton
                :items="importOptions"
                context="FileImport"
                :alvqa="alvqa"
            />
            <v-col 
                cols="4"
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="PublishingProjects" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
            <v-spacer />
            <v-col 
                cols="2"
                align-self="end"
            >
                <BaseButton 
                    label="lang_PUBLISHING_PROJECTS_BUTTON_CAPTION_NEW_PROJECT"
                    :to="{ name: editForm, params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import ImportButton from '@/components/_buttons/ImportButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "PublishingProjectsTopSlot",
    components: {
        BaseButton,
        ImportButton,
        BaseHeaderStats,
        ActionDropdown
    },    
    data() {
        return {
            editForm: "PublishingProjectsEdit",
            alvqa: "publishing-projects"
        }
    },
    computed: {
        actions() {
            return [
                { 
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE'),
                    value: 'move', 
                    alvqa: this.alvqa + '-list-action-dropdown-move'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        },
               
        importOptions() {
            return [
                { 
                    text: this.$t('lang_PUBLISHING_RELEASES_BUTTON_OPTION_ALV_TEMPLATE'), 
                    value: 'alvExcelTemplatePublishingProjects',
                    alvqa: this.alvqa + '-list-import-dropdown-alv-excel-template'
                },
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS'),
                    value: 'mappingImport',
                    alvqa: this.alvqa + '-list-import-dropdown-mapping-import'
                }
            ]
        }
    }
}
</script>